import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import StackedSection from '../StackedSection/StackedSection';

const FragranceSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$fragrance' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$fragrance' });

  return (
    <StackedSection
      text={t('text')}
      btnText={t('btn')}
      img="/images/homePage/westin-white-tea-fragrance-collection.webp"
      link={tLink('fragrance')}
      alt={t('btn')}
    />
  );
};

export default FragranceSection;
